export default __webpack_public_path__ + "static/media/ss3.d07563b6.JPG";